import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AnnouncementRoutingModule } from './announcement-routing.module';
import { AnnouncementComponent } from './announcement/announcement.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AddUpdateAnnouncementComponent } from './add-update-announcement/add-update-announcement.component';

@NgModule({
  declarations: [AnnouncementComponent, AddUpdateAnnouncementComponent],
  imports: [CommonModule, AnnouncementRoutingModule, SharedModule],
})
export class AnnouncementModule {}
